import { createContext, useState, useContext } from "react";

type TeamsAuthType = {
  voiceAIToken: string;
  firstName: string;
  isLoginEnabled: boolean | null;
  setVoiceAIToken: (voiceAIToken: string) => void;
  setFirstName: (firstName: string) => void;
  setIsLoginEnabled: (isLoginEnabled: boolean) => void;
};

export const TeamsAuthContext = createContext<TeamsAuthType | null>(null);

export const TeamsAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [voiceAIToken, setVoiceAIToken] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [isLoginEnabled, setIsLoginEnabled] = useState<boolean | null>(null);

  return (
    <TeamsAuthContext.Provider 
      value={{ 
        voiceAIToken, 
        firstName, 
        isLoginEnabled,
        setVoiceAIToken, 
        setFirstName,
        setIsLoginEnabled 
      }}
    >
      {children}
    </TeamsAuthContext.Provider>
  );
};